<template>
  <v-tooltip
    bottom
    color="white"
  >
    <template #activator="{ on }">
      <span
        v-on="on"
      >
        <slot />
      </span>
    </template>
    <div
      style="color:#000;font-size: 16px;"
    >
      <slot name="content" />
    </div>
  </v-tooltip>
</template>
<script>
export default {
  name: 'HoverTips',
}
</script>
